/*@ngInject*/
const SectionEditorController = function ($rootScope, $scope, $element, formViewerConstant, formMediator, formTemplateStatus, modalUtil, localization, authorizationConstants, currentUserModel, formViewerModel) {

    $element.addClass('componentEditor');

    this.translations = {};
    this.isDeleteVisible = false;
    this.userCanManageForms = false;

    this.$onInit = function () {
        this.userCanManageForms = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_FORMS);

        this.updateDeleteVisibility();

        localization.getTranslations().then(function (translations) {
            this.translations = translations;
        }.bind(this));
    };

    this.canDeleteSection = function () {
        return this.userCanManageForms &&
            this.sectionStructure.parentUiFormTemplate.formTemplate.status !== formTemplateStatus.IN_PRODUCTION &&
            this.formHasMultipleSections();
    };

    this.formHasMultipleSections = function () {
        const formStructure = formViewerModel.getFormStructure(this.rootFormId);
        return !_.isNil(formStructure) && _.size(formStructure.sectionList) > 1;
    };

    this.onDeleteComponentStructure = function () {
        let message = _.get(this.translations, 'sectionEditor.deleteSectionConfirmation.summary'),
            title = _.get(this.translations, 'sectionEditor.deleteSectionConfirmation.title'),
            cancelButtonLabel = _.get(this.translations, 'genericButtons.cancel'),
            confirmButtonLabel = _.get(this.translations, 'genericButtons.continue');

        function handleClose() {
            formMediator.deleteSection(this.rootFormId, this.sectionStructure.sectionStructureId);
        }

        if (this.canDeleteSection()) {
            modalUtil.showGenericConfirm({
                cancelButtonLabel: cancelButtonLabel,
                confirmActionButtonLabel: confirmButtonLabel,
                summary: message,
                title: title
            }).then(handleClose.bind(this));
        }
    };

    this.updateDeleteVisibility = function () {
        this.isDeleteVisible = this.canDeleteSection() && this.sectionStructure.selected;
    };

    $scope.$on(formViewerConstant.configuration.event.SECTION_SELECTION_CHANGE, function (event, sectionStructure) {
        this.sectionStructure.selected = sectionStructure.sectionStructureId === this.sectionStructure.sectionStructureId;
        this.updateDeleteVisibility();
    }.bind(this));

    $scope.$on(formViewerConstant.configuration.event.ROW_SELECTION_CHANGE, function () {
        this.sectionStructure.selected = false;
        this.updateDeleteVisibility();
    }.bind(this));

    $scope.$on(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, function () {
        this.sectionStructure.selected = false;
        this.updateDeleteVisibility();
    }.bind(this));

    $scope.$on(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED, function () {
        this.updateDeleteVisibility();
    }.bind(this));
};

angular.module('umFormViewer')
    .controller('sectionEditorController', SectionEditorController);
